import axios from 'axios'
import store from '@/store'

const instance = axios.create({
  baseURL: process.env.BACKEND_URL
})

instance.interceptors.request.use((config) => {
  const currentUser = store.getters.currentUser
  const now = new Date()
  if (Object.keys(currentUser).length > 0 && now >= new Date(currentUser.expirationDate)) {
    store.dispatch('refreshSession')
  }

  return config
})

export default instance



// WEBPACK FOOTER //
// ./src/axios-auth.js